// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-275d26e8] .ssr-modal>*{top:0!important;overflow-y:auto}[data-v-275d26e8] .ssr-modal div[data-modal]{position:static;box-sizing:border-box;left:0;top:0;width:100%;height:auto;background:none;z-index:1;opacity:1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
